import { logos } from '../Assets/Logo/logos'

export default function Companies() {
  return (
    <div className="other-companies">
      <div className="other-companies-logos">
        <div className="div-link">
          <a target="_blank" href="https://ammarhes.com.br/">
            <img
              className="other-companies-logos-Imgs"
              src={logos.ammarhesWrite}
              alt="Logo Ammarhes"
            />
          </a>
          <a
            target="_blank"
            href="https://ammarhes.com.br/"
            className="a-buttons"
          >
            Clique e Acesse
          </a>
        </div>

        <div className="div-link">
          <a target="_blank" href="https://casaocupacional.com.br/">
            <img
              className="other-companies-logos-Imgs"
              src={logos.casaOcupacional}
              alt="Logo Casa Ocupacional"
            />
          </a>
          <a
            target="_blank"
            href="https://casaocupacional.com.br/"
            className="a-buttons"
          >
            Clique e Acesse
          </a>
        </div>
        <div className="div-link">
          <a target="_blank" href="https://www.agendatecnica.com.br/">
            <img
              className="other-companies-logos-Imgs"
              src={logos.agenda}
              alt="Logo Agenda Técnica"
            />
          </a>
          <a
            target="_blank"
            href="https://www.agendatecnica.com.br/"
            className="a-buttons"
          >
            Clique e Acesse
          </a>
        </div>
        {/* <div className="div-link">
          <a target="_blank" href="https://saude10clinica.com.br/">
            <img
              className="other-companies-logos-Imgs"
              src={logos.saude10}
              alt="Logo Saúde 10"
              id="saude10"
            />
          </a>
          <a
            target="_blank"
            href="https://saude10clinica.com.br/"
            className="a-buttons"
          >
            Clique e Acesse
          </a>
        </div> */}
      </div>
    </div>
  )
}
